import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import CreateHpDeviceProvider from "./baseProviders/createHpDeviceProvider"
import useStartNewHpDeviceVersion from "../../../../../services/middleware/hooks/devices/lct/useStartNewHpDeviceVersion"

interface INewHpDeviceVersionFormUrlParams {
    deviceRef: string
}

interface INewHpDeviceVersionProviderProps {
    children: ReactNode
}

const NewHpDeviceVersionProvider = ({
    children,
}: INewHpDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewHpDeviceVersionFormUrlParams
    >() as INewHpDeviceVersionFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newHpDeviceVersionError,
        apiResSystemRef: systemReference,
    } = useStartNewHpDeviceVersion(urlDeviceRef, attachmentUUID)

    return (
        <CreateHpDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newHpDeviceVersionError}
            attachmentUUID={attachmentUUID}
            systemReference={systemReference ?? ""}
            canEditManufacturer={false}
        >
            {children}
        </CreateHpDeviceProvider>
    )
}

export default NewHpDeviceVersionProvider
